import * as keyapis_banner_v1_banner_pb from "./v1/keyapis_banner_banner_v1.pb";
import * as keyapis_banner_v1_system_pb from "./v1/keyapis_banner_system_v1.pb";

export default {
  v1: {
    resources: {
      banner: keyapis_banner_v1_banner_pb,
      system: keyapis_banner_v1_system_pb,
    },
  },
};
